<template>
  <div class="w-full lg:w-1/2 mx-auto" v-if="opportunity != null">
    <div class="text-2xl">
      Please confirm this import
    </div>

    <div class="my-6">
      <div class="text-base leading-normal">
        You have selected the following opportunity in Mercury to import as a new client.
        Please review and confirm to add this opportunity as a new client.
      </div>

      <div v-if="opportunity.clients.length > 0" class="mt-4 mb-2 text-sm border border-red-500 bg-red-100 p-4">
        There are clients already in {{ getAppName }} with the same applicants who are in 
        the opportunity that you are about to import.

        <div class="mt-2">
          <template v-for="(client, index) in opportunity.clients">
            <div class="mt-1">
              <router-link
                :to="{
                  name : 'application-applicant-profile',
                  params : {
                    clientId   : client.client_id,
                    applicantId: client.applicant_id
                  }
                }"
                tag="a"
                target="_blank"
                class="text-blue-600 no-underline hover:underline text-sm">
                {{ client.first_name }}
                {{ client.last_name }} - 
                {{ client.email }}    
              </router-link>
            </div>
          </template>
        </div>
      </div>

      <div class="mt-8 bg-gray-100 p-4">
        <Opportunity v-bind:opportunity="opportunity" />
      </div>

      <div class="mt-8">
        <SubmitButton label="Confirm &amp; Import" v-bind:onClick="submit" v-bind:loading="loading"></SubmitButton>
      </div>

      <v-dialog />
    </div>
  </div>
</template>

<script>
  import { EventBus }     from '@/shared/event-bus';
  import PageHeader       from '@/shared/components/headers/PageHeader'
  import SubmitButton     from '@/shared/components/form/SubmitButton'
  import Opportunity      from './Opportunity'
  // import Footer           from '@/shared/components/Footer'

  export default {

    components : {
      SubmitButton,
      PageHeader,
      Opportunity
      // Footer
    },

    data() {
      return {
        loading    : false,
        opportunity: null
      }
    },

    created() {
      this.showLoader("Verifying...")
      this.apiGet({
        opportunityId : this.$route.params.opportunityId
      }, 'mercury/opportunity', (opportunity) => {
        this.hideLoader()
        this.opportunity = opportunity
      })
    },

    methods : {
      submit() {
        this.loading = true
        this.apiPost({
          opportunityId : this.opportunity.id,
        }, 'mercury/create-client-from-opportunity', (data) => {
          this.loading = false
          this.$router.push({
            name : 'mercury-opportunity-import-success', 
            params : {
              clientId   : data.client.id,
              applicantId: data.applicant.id
            }
          })
        })
      },
    }
  }
</script>